import { Component, Injector } from '@angular/core';
import { NgControl } from '@angular/forms';

import { OrganisationDropdownComponentConfigurator } from './organisation-dropdown-component.configurator';
import { BaseMultiselectDropdownComponent } from '@pl/pl-lib/forms';
import { Organisation } from 'src/app/core/models/organisation';

@Component({
  selector: 'app-organisation-multiselect-dropdown',
  templateUrl:
    '../../../../../../node_modules/@pl/pl-lib/assets/templates/searchable-dropdown/multiselect-dropdown.component.html',
  styleUrls: [
    '../../../../plLibSetup/components/searchable-dropdown/multiselect-dropdown.component.scss'
  ]
})
export class OrganisationMultiselectDropdownComponent extends BaseMultiselectDropdownComponent<Organisation> {
  constructor(ngControl: NgControl, injector: Injector) {
    super(ngControl, injector);
    this.configurator = new OrganisationDropdownComponentConfigurator();
  }
}
